// latest: zhangmyh 2017-9-18 5:12 PM
/* global $ u ko */
import 'components/filesupload'
import { Get } from 'common'
let _model

function getLocalTime (nS) {
  return (new Date(nS)).toLocaleDateString() + ' ' + (new Date(nS)).toLocaleTimeString()
}

async function init (refer) {
  let result = await Get(`/cpu-supplymgr/qixinchange/showQixinChange?supplyId=${refer.options.data}`)
  let vm = {
    enterpriseId: ko.observable(window.global.user.PURCHASEID),
    qixinDetail: '',
    supplyDoc: '',
    qxapply: ''
  }
  // base
  vm.qixinDetail = {
    name: '',
    busLicenceNum: '',
    organizationCode: '',
    entRegisterNo: '',
    entTypeName: '',
    artificialPsn: '',
    registerAddress: '',
    registerMny: '',
    currencyName: '',
    foundDate: '',
    serviceRange: '',
    serviceRangeDeadline: ''
  }
  Object.assign(vm.qixinDetail, result.data.qixinDetail)
  if (vm.qixinDetail.foundDate) {
    vm.qixinDetail.foundDate = getLocalTime(vm.qixinDetail.foundDate)
  }
  if (vm.qixinDetail.registerMny) {
    vm.qixinDetail.registerMny += '万元'
  }
  // change
  vm.supplyDoc = {
    name: '',
    businessLicenseNo: '',
    organizationCode: '',
    entRegisterNo: '',
    entTypeName: '',
    legalBody: '',
    registerAddress: '',
    registerFund: '',
    currencyName: '',
    foundDate: '',
    serviceRange: '',
    serviceRangeDeadline: ''
  }
  Object.assign(vm.supplyDoc, result.data.supplyDoc)
  if (vm.supplyDoc.foundDate) {
    vm.supplyDoc.foundDate = getLocalTime(vm.supplyDoc.foundDate)
  }
  if (vm.supplyDoc.registerFund) {
    vm.supplyDoc.registerFund += '万元'
  }
  vm.model = _model

  vm.model.on('status.valuechange', function ({ oldValue, newValue }) {
    let advice = ''
    if (newValue == 1) {
      advice = '审批通过，工商信息更新。'
    } else if (newValue == 2) {
      advice = '审批不通过，具体原因如下:\n'
    }
    _model.setValue('advice', advice)
  })

  let app = u.createApp()
  await app.init(vm, $('#showChange_info')[0])
  for (let i = 0; i < 12; i++) {
    let base = $('.info-base p span:last-child').eq(i).html()
    let change = $('.info-change p span:last-child').eq(i).html()
    // 高度对比一下
    let _height = $('.info-base p').eq(i).height()
    let _height2 = $('.info-change p').eq(i).height()
    if (_height > _height2) {
      $('.info-change p').eq(i).height(_height)
    }
    if (_height2 > _height) {
      $('.info-base p').eq(i).height(_height2)
    }
    if (base != change) {
      $('.info-base p').eq(i).addClass('changed')
    }
  }
}

let template = require('./index.html')
export default function (model) {
  _model = model
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qxchange/deal/index.js